<app-base-template (modal)="openModal(content)" (tabledata)="getTableData()" [displayData]="displayData"
                   [nextOffset]="nextOffset"
                   [previousOffset]="previousOffset" (offset)="getData($event)"
                   (pageSize)="onPageSizeChange($event)" [pageNo]="page_no" [totalPage]="totalPage"
                   [showSearch]="showSearch" [dataLoaded]="dataLoaded"></app-base-template>
<ng-template #content let-c="close" let-d="dismiss">
    <div class="modal-header modalTitle">
        <div class="modal-title">Add Notification</div>

    </div>
    <div class="modal-body height-500 overflow-auto">
        <div class="none" [ngClass]="{'inputError':isError}">{{errorMessage}}</div>
        <div class="form-group">
            <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="ticketTypeSelected"
                    (change)="onTicketChange($event.target.selectedIndex)">
                <option *ngFor="let ticket of ttypes" [value]="ticket.id">{{ticket.name}}</option>
            </select>
        </div>

        <div class="form-group">
            <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="statusSelected">
                <option *ngFor="let stat of status" [value]="stat.seq">{{stat.name}}</option>
            </select>
        </div>
        <div class="form-group">
            <select class="custom-select mr-sm-2 radius-0 font-13"
                    [(ngModel)]="catSelected" (change)="onCategoryChange($event.target.selectedIndex)">
                <option *ngFor="let category of categories" [value]="category.id">{{category.name}}</option>
            </select>
        </div>
        <div class="form-group">
<!--            <label>Select Tiles :</label><br>-->
<!--            <mat-checkbox class="font-13" *ngFor="let menu of menuDtl" value="{{menu.id}}"-->
<!--                          [(ngModel)]="menu.checked">{{menu.name}}</mat-checkbox>-->
            <select class="custom-select mr-sm-2 radius-0 font-13" [(ngModel)]="menuSelected">
                <option *ngFor="let menu of menuDtl" [value]="menu.id">{{menu.name}}</option>
            </select>
        </div>
        <div class="form-group ticket-menu">
            <label>Select Support Groups :</label><br>
            <mat-checkbox class ="font-13" *ngFor ="let group of groups" value="{{group.id}}"
                          [(ngModel)]="group.checked">{{group.name}}</mat-checkbox>
        </div>
    </div>
    <div class="modal-footer pad-8">
        <button type="button" class="btn btn-success radius-0" (click)="save()">Save</button>
        <button type="button" class="btn btn-danger radius-0" (click)="c()">Cancel</button>
    </div>
</ng-template>

<notifier-container></notifier-container>

